import safeFetch from '@/lib/helpers/safe-fetch'
import { passCacheClientSingleton } from '@/lib/cache/client'
import { CS_CACHE_TIME } from '@/lib/constants'
import Logger from '@/lib/logger'

const logger = new Logger('pbs:helpers:cached-fetch')

// NOTE: the return type is intentionally `any`. The value comes from either a
// cached JSON blob or `response.json()` (both structurally unknown at this
// boundary) and callers immediately reach into shape-specific fields
// (`json.data`, etc.). Narrowing this to `unknown`/generic is a separate,
// larger refactor tracked alongside the JSON.parse any-leak audit (RWEB-9903).
// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function cachedFetch(input: RequestInfo | URL, ttl: number = CS_CACHE_TIME, init?: RequestInit): Promise<any> {
  const cacheClient = await passCacheClientSingleton()
  const key = input.toString()
  const cachedResponse = await cacheClient.get(key)

  if(cachedResponse) {
    return cachedResponse
  }

  logger.debug(`Requesting cached object for key: ${key}`)

  const response = await safeFetch(input, { ...init, cache: 'no-store' })
  const contentType = response.headers.get('content-type')

  if(contentType?.includes('application/json')) {
    var body = await response.json()
  } else {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var body: any = await response.text()
  }

  cacheClient.set(key, body, ttl, { allowGraduatedResponse: true })
  return body
}

export default cachedFetch
